(() => {
  const CONFIG = {
    gifts: [
      {
        name: 'shaker',
        variantId: 49964310954322,
        threshold: 10000
      },
      {
        name: 'booster',
        variantId: 49964311347538,
        threshold: 15000
      }
    ]
  };

  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);

  let lastCart = null;
  let syncRunning = false;
  let checkTimer = null;

  function suppressionKey(gift) {
    return 'naway_gift_removed_' + gift.name;
  }

  function isSuppressed(gift) {
    return sessionStorage.getItem(suppressionKey(gift)) === '1';
  }

  function suppress(gift) {
    sessionStorage.setItem(suppressionKey(gift), '1');
  }

  function clearSuppression(gift) {
    sessionStorage.removeItem(suppressionKey(gift));
  }

  async function getCart() {
    const response = await nativeFetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart konnte nicht geladen werden.');
    }

    return response.json();
  }

  function isNawayGiftLine(item) {
    const properties = item.properties || {};

    return CONFIG.gifts.some(gift => {
      return (
        String(item.variant_id) === String(gift.variantId) &&
        properties._naway_free_gift === gift.name
      );
    });
  }

  function getQualifyingSubtotal(cart) {
    return cart.items.reduce((total, item) => {
      if (isNawayGiftLine(item)) {
        return total;
      }

      let price = 0;

      if (typeof item.original_line_price === 'number') {
        price = item.original_line_price;
      } else if (
        typeof item.original_price === 'number' &&
        typeof item.quantity === 'number'
      ) {
        price = item.original_price * item.quantity;
      } else if (typeof item.line_price === 'number') {
        price = item.line_price;
      } else if (typeof item.final_line_price === 'number') {
        price = item.final_line_price;
      }

      return total + price;
    }, 0);
  }

  function getGiftLine(cart, gift) {
    return cart.items.find(item => {
      const properties = item.properties || {};

      return (
        String(item.variant_id) === String(gift.variantId) &&
        properties._naway_free_gift === gift.name
      );
    });
  }

  async function addGifts(gifts) {
    if (!gifts.length) return;

    const response = await nativeFetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: gifts.map(gift => ({
          id: gift.variantId,
          quantity: 1,
          properties: {
            _naway_free_gift: gift.name
          }
        }))
      })
    });

    if (!response.ok) {
      const message = await response.text();

      throw new Error(
        'Geschenk konnte nicht hinzugefügt werden: ' + message
      );
    }
  }

  async function changeLine(lineKey, quantity) {
    const response = await nativeFetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('Warenkorb konnte nicht geändert werden.');
    }
  }

  async function syncGifts(cart) {
    if (syncRunning) return false;

    syncRunning = true;

    try {
      const subtotal = getQualifyingSubtotal(cart);
      let changed = false;

      CONFIG.gifts.forEach(gift => {
        if (subtotal < gift.threshold) {
          clearSuppression(gift);
        }
      });

      for (const gift of CONFIG.gifts) {
        const line = getGiftLine(cart, gift);

        if (line && subtotal < gift.threshold) {
          await changeLine(line.key, 0);
          changed = true;
        }
      }

      for (const gift of CONFIG.gifts) {
        const line = getGiftLine(cart, gift);

        if (
          line &&
          subtotal >= gift.threshold &&
          line.quantity !== 1
        ) {
          await changeLine(line.key, 1);
          changed = true;
        }
      }

      const giftsToAdd = CONFIG.gifts.filter(gift => {
        const qualified = subtotal >= gift.threshold;
        const alreadyThere = Boolean(getGiftLine(cart, gift));

        return (
          qualified &&
          !alreadyThere &&
          !isSuppressed(gift)
        );
      });

      if (giftsToAdd.length) {
        await addGifts(giftsToAdd);
        changed = true;
      }

      if (changed) {
        setTimeout(() => {
          window.location.reload();
        }, 200);

        return true;
      }

      lastCart = cart;
      return false;

    } catch (error) {
      console.error('[Naway Free Gifts]', error);
      return false;

    } finally {
      syncRunning = false;
    }
  }

  async function checkCart() {
    if (syncRunning) return;

    try {
      const cart = await getCart();

      if (lastCart) {
        const subtotal = getQualifyingSubtotal(cart);

        CONFIG.gifts.forEach(gift => {
          const existedBefore = Boolean(
            getGiftLine(lastCart, gift)
          );

          const existsNow = Boolean(
            getGiftLine(cart, gift)
          );

          if (
            existedBefore &&
            !existsNow &&
            subtotal >= gift.threshold
          ) {
            suppress(gift);
          }
        });
      }

      await syncGifts(cart);

    } catch (error) {
      console.error('[Naway Free Gifts]', error);
    }
  }

  function scheduleCheck() {
    clearTimeout(checkTimer);

    checkTimer = setTimeout(() => {
      checkCart();
    }, 300);
  }

  function isCartMutation(url, method) {
    if (!url) return false;

    method = String(method || 'GET').toUpperCase();

    if (method === 'GET') {
      return false;
    }

    return /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(
      String(url)
    );
  }

  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);

    try {
      const input = args[0];

      const url =
        typeof input === 'string'
          ? input
          : input?.url;

      const method =
        args[1]?.method ||
        input?.method ||
        'GET';

      if (isCartMutation(url, method)) {
        scheduleCheck();
      }

    } catch (error) {}

    return response;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url,
    ...rest
  ) {
    this._nawayCartMutation =
      isCartMutation(url, method);

    return nativeOpen.call(
      this,
      method,
      url,
      ...rest
    );
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this._nawayCartMutation) {
      this.addEventListener(
        'loadend',
        scheduleCheck,
        { once: true }
      );
    }

    return nativeSend.apply(this, args);
  };

  getCart()
    .then(cart => {
      lastCart = cart;
      return syncGifts(cart);
    })
    .catch(error => {
      console.error('[Naway Free Gifts]', error);
    });

})();